import React from 'react'
import Slider from 'react-slick'
import image from '../../assets/homepage_img2.png'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const BannerCarousel = () => {
    const a = [1, 2, 3, 4, 5]
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
    }
    return (
        <>
            <section className="d-flex" style={{marginTop:'35px'}} >
                <div className="container-fluid" style={{padding:'0px'}}>
                    
                            <Slider {...sliderSettings}>
                                {a.map((i,index) => (
                                    
                                        <div key={index} className="make-bx d-flex align-items-center justify-content-between">
                                            <div className="make-txt">
                                                <h3>
                                                    <span>Start to</span> Make your own PC
                                                </h3>
                                                <h5>3 Types of PC Building is available</h5>
                                                <p>Office PC, Gaming PC, and Custom PC</p>
                                                <h4>
                                                    Office PC Start from <span>Tk 18,000</span>
                                                </h4>
                                                <a href="#" className="btn-buy">
                                                    Build Your office PC
                                                </a>
                                            </div>
                                            <div className="mubarak-img">
                                                <img className="img-fluid" src={image} alt="" />
                                            </div>
                                        </div>
                                ))}
                            </Slider>
                        </div>
            </section>
        </>
    )
}

export default BannerCarousel